export default __webpack_public_path__ + "static/media/rectangle.86ec97ff.svg";